import { DataTable } from 'mantine-datatable';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const PredictionCard = (props) => {
    const [teams, setTeams] = useState();
    const [keys, setKeys] = useState();

    const { number } = useParams();

    useEffect(() => {
        if (props.alliance && keys) {
            let correctedTeams = []

            Object.keys(props.alliance).map((i)=> {
                console.log(props.alliance[i])
                correctedTeams.push({"key": keys[i].slice(3), "match": (props.alliance[i].qm || {})[number] || {}})
            })
            setTeams(correctedTeams);
            console.log(correctedTeams);
        }
        if (props.keys) {
            setKeys(props.keys);
        }
    }, [props])

    if (teams) {
        return (
            <DataTable
                withBorder
                withColumnBorders
                striped
                highlightOnHover
                borderColor={(props.color === "red" ? props.color : props.color)}
                records={[
//                    {
//                        column1: ("Auto Fuel"),
//                        column2: (`${teams[0].match.autoFuel?teams[0].match.autoFuel:"N/A"} | ${Math.round((teams[0].match.autoFuelAcc || 0)*10000)/100}%`),
//                        column3: (`${teams[1].match.autoFuel?teams[1].match.autoFuel:"N/A"} | ${Math.round((teams[1].match.autoFuelAcc || 0)*10000)/100}%`),
//                        column4: (`${teams[2].match.autoFuel?teams[2].match.autoFuel:"N/A"} | ${Math.round((teams[2].match.autoFuelAcc || 0)*10000)/100}%`),
//                    },
                    {
                        column1: ("Auto Missed Fuel"),
                        column2: (teams[0].match.autoMissedFuel || "N/A"),
                        column3: (teams[1].match.autoMissedFuel || "N/A"),
                        column4: (teams[2].match.autoMissedFuel || "N/A"),
                    },
                    {
                        column1: ("Auto Shuttled Fuel"),
                        column2: (teams[0].match.autoShuttledFuel || "N/A"),
                        column3: (teams[1].match.autoShuttledFuel || "N/A"),
                        column4: (teams[2].match.autoShuttledFuel || "N/A"),
                    },
                    {
                        column1: ("Auto Points"),
                        column2: (teams[0].match.autoPoints || 0),
                        column3: (teams[1].match.autoPoints || 0),
                        column4: (teams[2].match.autoPoints || 0),
                    },
//                    {
//                        column1: ("Teleop Fuel"),
//                        column2: (`${teams[0].match.teleopFuel?teams[0].match.teleopFuel:"N/A"} | ${Math.round((teams[0].match.teleopFuelAcc || 0)*10000)/100}%`),
//                        column3: (`${teams[1].match.teleopFuel?teams[1].match.teleopFuel:"N/A"} | ${Math.round((teams[1].match.teleopFuelAcc || 0)*10000)/100}%`),
//                        column4: (`${teams[2].match.teleopFuel?teams[2].match.teleopFuel:"N/A"} | ${Math.round((teams[2].match.teleopFuelAcc || 0)*10000)/100}%`),
//                    },
                    {
                        column1: ("Teleop Missed Fuel"),
                        column2: (teams[0].match.teleopMissedFuel || "N/A"),
                        column3: (teams[1].match.teleopMissedFuel || "N/A"),
                        column4: (teams[2].match.teleopMissedFuel || "N/A"),
                    },
                    {
                        column1: ("Teleop Shuttled Fuel"),
                        column2: (teams[0].match.teleopShuttledFuel || "N/A"),
                        column3: (teams[1].match.teleopShuttledFuel || "N/A"),
                        column4: (teams[2].match.teleopShuttledFuel || "N/A"),
                    },
                    {
                        column1: ("Teleop Points"),
                        column2: (teams[0].match.teleopPoints || 0),
                        column3: (teams[1].match.teleopPoints || 0),
                        column4: (teams[2].match.teleopPoints || 0),
                    },
                    {
                        column1: ("Average Fuel/min"),
                        column2: (teams[0].match.avgFuelPerMin || "N/A"),
                        column3: (teams[1].match.avgFuelPerMin || "N/A"),
                        column4: (teams[2].match.avgFuelPerMin || "N/A"),
                    },
//                    {
//                        column1: ("Total Fuel Scored"),
//                        column2: (teams[0].match.totalFuelScored || "N/A"),
//                        column3: (teams[1].match.totalFuelScored || "N/A"),
//                        column4: (teams[2].match.totalFuelScored || "N/A"),
//                    },
//                    {
//                        column1: ("Total Fuel Missed"),
//                        column2: (teams[0].match.totalFuelMissed || "N/A"),
//                        column3: (teams[1].match.totalFuelMissed || "N/A"),
//                        column4: (teams[2].match.totalFuelMissed || "N/A"),
//                    },
//                    {
//                        column1: ("Fuel Accuracy"),
//                        column2: (teams[0].match.totalFuelScored || 0) + (teams[0].match.totalFuelMissed || 0) > 0
//                            ? `${Math.round(((teams[0].match.totalFuelScored || 0) / ((teams[0].match.totalFuelScored || 0) + (teams[0].match.totalFuelMissed || 0))) * 10000) / 100}%`
//                            : "N/A",
//                        column3: (teams[1].match.totalFuelScored || 0) + (teams[1].match.totalFuelMissed || 0) > 0
//                            ? `${Math.round(((teams[1].match.totalFuelScored || 0) / ((teams[1].match.totalFuelScored || 0) + (teams[1].match.totalFuelMissed || 0))) * 10000) / 100}%`
//                            : "N/A",
//                        column4: (teams[2].match.totalFuelScored || 0) + (teams[2].match.totalFuelMissed || 0) > 0
//                            ? `${Math.round(((teams[2].match.totalFuelScored || 0) / ((teams[2].match.totalFuelScored || 0) + (teams[2].match.totalFuelMissed || 0))) * 10000) / 100}%`
//                            : "N/A",
//                    },
//                    {
//                        column1: ("Intake Locations"),
//                        column2: (teams[0].match.intakeLocations ? teams[0].match.intakeLocations.join(", ") : "N/A"),
//                        column3: (teams[1].match.intakeLocations ? teams[1].match.intakeLocations.join(", ") : "N/A"),
//                        column4: (teams[2].match.intakeLocations ? teams[2].match.intakeLocations.join(", ") : "N/A"),
//                    },
                    {
                        column1: ("Auto Climb Status"),
                        column2: (teams[0].match.autoClimbStatus || "N/A"),
                        column3: (teams[1].match.autoClimbStatus || "N/A"),
                        column4: (teams[2].match.autoClimbStatus || "N/A"),
                    },
                    {
                        column1: ("Endgame Climb Status"),
                        column2: (teams[0].match.endgameClimbStatus || "N/A"),
                        column3: (teams[1].match.endgameClimbStatus || "N/A"),
                        column4: (teams[2].match.endgameClimbStatus || "N/A"),
                    },
//                    {
//                        column1: ("Endgame Points"),
//                        column2: (teams[0].match.endgamePoints || 0),
//                        column3: (teams[1].match.endgamePoints || 0),
//                        column4: (teams[2].match.endgamePoints || 0),
//                    },
//                    {
//                        column1: ("Total Points"),
//                        column2: (teams[0].match.totalPoints || 0),
//                        column3: (teams[1].match.totalPoints || 0),
//                        column4: (teams[2].match.totalPoints || 0),
//                    },
                    {
                        column1: ("Died"),
                        column2: (teams[0].match.died ? "Buddy Died" : "he livin"),
                        column3: (teams[1].match.died ? "Buddy Died" : "he livin"),
                        column4: (teams[2].match.died ? "Buddy Died" : "he livin"),
                    },
                    {
                        column1: ("Tipped"),
                        column2: (teams[0].match.tipped ? "Tipped" : "Stable"),
                        column3: (teams[1].match.tipped ? "Tipped" : "Stable"),
                        column4: (teams[2].match.tipped ? "Tipped" : "Stable"),
                    },
                    {
                        column1: ("Driver Rating"),
                        column2: (teams[0].match.driverRating || "N/A"),
                        column3: (teams[1].match.driverRating || "N/A"),
                        column4: (teams[2].match.driverRating || "N/A"),
                    },
                    {
                        column1: ("Defense Rating"),
                        column2: (teams[0].match.defenseRating || "N/A"),
                        column3: (teams[1].match.defenseRating || "N/A"),
                        column4: (teams[2].match.defenseRating || "N/A"),
                    },
                    {
                        column1: ("Intake Rating"),
                        column2: (teams[0].match.intakeRating || "N/A"),
                        column3: (teams[1].match.intakeRating || "N/A"),
                        column4: (teams[2].match.intakeRating || "N/A"),
                    },
                    {
                        column1: ("Climb Rating"),
                        column2: (teams[0].match.climbRating || "N/A"),
                        column3: (teams[1].match.climbRating || "N/A"),
                        column4: (teams[2].match.climbRating || "N/A"),
                    },
//                    {
//                        column1: ("Average Rating"),
//                        column2: (teams[0].match.averageRating || "N/A"),
//                        column3: (teams[1].match.averageRating || "N/A"),
//                        column4: (teams[2].match.averageRating || "N/A"),
//                    },
                    {
                        column1: ("Scouting Accuracy"),
                        column2: (`Total: ${props.totalPoints || 0}`),
                        column3: (`Scouted: ${(teams[0].match.totalPoints || 0) + (teams[1].match.totalPoints || 0) + (teams[2].match.totalPoints || 0)}`),
                        column4: props.totalPoints
                            ? `Accuracy: ${Math.round(((teams[0].match.totalPoints || 0) + (teams[1].match.totalPoints || 0) + (teams[2].match.totalPoints || 0)) / props.totalPoints * 10000) / 100}%`
                            : "N/A",
                    }
                ]}
                columns={[
                    { accessor: 'column1', title: "Data", width: 20, textAlignment: 'center', ellipsis: true},
                    { accessor: 'column2', title: String(teams[0].key), width: 15, textAlignment: 'center'},
                    { accessor: 'column3', title: String(teams[1].key), width: 15, textAlignment: 'center'},
                    { accessor: 'column4', title: String(teams[2].key), width: 15, textAlignment: 'center'},
                ]}
            />
        );
    }
}

export default PredictionCard;